export function normaliseViewLanguage(value) {
  const code = String(value || '').trim().replace(/_/g, '-');
  if (!/^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/i.test(code)) return '';
  const base = code.split('-')[0].toLowerCase();
  if (['und', 'mul', 'zxx'].includes(base)) return '';
  if (base === 'zh') return /(?:hant|tw|hk|mo)/i.test(code) ? 'zh-TW' : 'zh-CN';
  const script = code.split('-').find((part, i) => i && /^[a-z]{4}$/i.test(part));
  if (script) return `${base}-${script[0].toUpperCase()}${script.slice(1).toLowerCase()}`;
  return ({ iw: 'he', jw: 'jv' })[base] || base;
}
export function systemViewLanguage(languages) {
  for (const language of languages || []) { const code = normaliseViewLanguage(language); if (code) return code; }
  return 'en';
}
export function sameViewLanguage(a, b) { return !!normaliseViewLanguage(a) && normaliseViewLanguage(a) === normaliseViewLanguage(b); }
export function languageName(code, locale) {
  if (code === 'zh-CN' && !locale) return '简体中文';
  if (code === 'zh-TW' && !locale) return '繁體中文';
  try { return new Intl.DisplayNames([locale || code], { type: 'language' }).of(code); } catch { return code; }
}
